export default {
  title: 'Studio (V2)',
  description: 'Opbyg og administrer restaurantens hjemmeside med det nye Website Studio.',
  retry: 'Prøv igen',
  deleted: 'Projekt slettet.',
  errors: {
    load: 'Studio (V2)-projektet kunne ikke indlæses.',
    create: 'Projektet kunne ikke oprettes. Prøv igen.',
    delete: 'Projektet kunne ikke slettes. Prøv igen.',
  },
  EmptyState: {
    title: 'Intet Studio (V2)-projekt endnu',
    description: 'Opret et projekt for at bygge hjemmesiden i det nye Website Studio. Studio (V1) forbliver uændret.',
    description_no_access: 'En onboarding-manager kan oprette projektet for dette brand.',
    create: 'Opret projekt',
  },
  ProjectCard: {
    unnamed: 'Unavngivet projekt',
    edit: 'Rediger i Studio',
    delete: 'Slet',
    open: 'Åbn',
    no_domain: 'Intet domæne endnu',
    fields: {
      uuid: 'UUID',
      domain: 'Domæne',
      websites: 'Hjemmesider',
    },
    delete_confirm: {
      title: 'Slet dette projekt?',
      description: 'Dette fjerner Studio (V2)-projektet og dets hjemmesider. Du kan oprette et nyt senere.',
      ok: 'Slet',
      cancel: 'Annuller',
    },
  },
};
